export default __webpack_public_path__ + "static/media/first_disabled.408488a8.svg";